import { Box, Button, Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { GetWithdrawableContractsResponseDto } from '../../../core/api/dtos';
import { getSitekey } from '../../../core/common/recaptcha';
import { injectTSDI } from '../../../core/common/tsdi';
import { I18n } from '../../../core/i18n';
import { BottomPaddedGridItemS, StyledReCAPTCHA } from '../../styles';
import { ContractWithdrawalStore } from '../contract-withdrawal-store';
import { ConfirmationEmailInput } from '../inputs/confirmation-email-input';

export interface ContractWithdrawalFormProps {
    contract: GetWithdrawableContractsResponseDto;
}

export const ContractWithdrawalForm = observer(
    (props: ContractWithdrawalFormProps) => {
        const recaptchaRef = React.createRef<ReCAPTCHA>();
        const { translate } = injectTSDI(I18n);
        const contractWithdrawalStore = injectTSDI(ContractWithdrawalStore);

        const withdrawContractForm =
            contractWithdrawalStore.getWithdrawContractForm(
                props.contract.contractId
            );

        if (!withdrawContractForm || !props.contract.contractId) {
            return <></>;
        }

        const { contractId } = props.contract;

        const { confirmationEmail } = withdrawContractForm.wrappedField;

        return (
            <Grid container spacing={3}>
                <Box width="100%" />
                <BottomPaddedGridItemS item xs={12} sm={6}>
                    <ConfirmationEmailInput
                        confirmationEmailField={confirmationEmail}
                        data-role="confirmation-email"
                    />
                </BottomPaddedGridItemS>
                <Grid item xs={12}>
                    <StyledReCAPTCHA
                        sitekey={getSitekey()}
                        ref={recaptchaRef}
                        size="invisible"
                    />
                    <Button
                        variant="contained"
                        color="secondary"
                        data-role="submit-withdraw-contract"
                        onClick={() =>
                            contractWithdrawalStore.handleWithdraw(
                                recaptchaRef,
                                contractId
                            )
                        }
                    >
                        {translate(
                            'public.content.withdraw.confirm.contract.withdrawal'
                        )}
                    </Button>
                </Grid>
            </Grid>
        );
    }
);
